import { useState } from "react";
import { Input } from "./ui/input";
import { getOffsetMm, setOffsetMm } from "../lib/casierLabel";

export function OffsetField({ onChange }) {
  const [offset, setOffset] = useState(getOffsetMm());
  return (
    <label className="text-xs flex items-center gap-2">Décalage depuis le bord gauche (mm)
      <Input type="number" step="0.5" min="0" className="w-24 h-8" value={offset} data-testid="casiers-offset"
        onChange={(e) => { const v = Math.max(0, parseFloat(e.target.value) || 0); setOffset(v); setOffsetMm(v); onChange?.(v); }} />
      <span className="text-muted-foreground">à ajuster si l'impression est décalée sur l'autocollant</span>
    </label>
  );
}
